import { yandexMetrika } from '@/helpers/yandexMetrika'
import { MobileApps } from '@/store/slices/stagesSlice/interfaces'

export const ONELINK_MOBILE_APP = 'https://onelink.to/k3wz3u'
export const getDataForMobileAppLinks = (mobileApps: MobileApps) => {
  const links = [
    {
      name: 'ios_link',
      link: ONELINK_MOBILE_APP,
      img: '/images/AppStoreButton.png',
      onClick: yandexMetrika.reachGoalButtonClickAppStoreNew,
      onView: yandexMetrika.reachGoalButtonViewAppStoreNew,
    },
    {
      name: 'android_link',
      link: ONELINK_MOBILE_APP,
      img: '/images/GoogleButton.png',
      onClick: yandexMetrika.reachGoalButtonClickGooglePlayNew,
      onView: yandexMetrika.reachGoalButtonViewGooglePlayNew,
    },
  ]

  if (mobileApps.rustore_link) {
    links.push({
      name: 'rustore_link',
      link: mobileApps.rustore_link,
      img: '/images/RustoreButton.png',
      onClick: () => {},
      onView: () => {},
    })
  }

  return links
}
